<div class="input-group col-12">
    <mat-form-field appearance="outline" [style]="Control.Style">
        <mat-label *ngIf="BindingProperty">{{Title||"" | translate}}</mat-label>

        <input matInput *ngIf="BindingProperty" type="text" [id]="DomID" [formControl]="BindingProperty"
            [title]="DescriptionText" [ngClass]="{'error': BindingProperty?.errors?.['incorrect']}"
            (change)="OnTextChange($event)" (contextmenu)="openMenu($event)"
            [value]="lookupValue !== undefined && lookupValue !== null ? lookupValue : ''" (mouseover)="OnInputHover()"
            (focus)="OnInputFocus()" class="input-lookup">


        <input matInput *ngIf="!BindingProperty" type="text" [id]="DomID" [title]="DescriptionText"
            [ngClass]="{'error': !Isvalid}" (change)="OnTextChange($event)"
            [value]="lookupValue !== undefined && lookupValue !== null ? lookupValue : ''" (mouseover)="OnInputHover()"
            (focus)="OnInputFocus()" [disabled]="IsDisabled">


        <span matSuffix class="lookup-icon">
            <validation-error-tool-tip [FormControl]="BindingProperty" [Control]="Control" [ControlType]="'lookup'"
                [LookupIncorrectErrorMsg]="ErrorMsg">

            </validation-error-tool-tip>
            <div class="input-group-append">
                <button kendoButton title="..." tabindex="-1" (click)="openDialog()"
                    [disabled]="BindingProperty?BindingProperty.disabled:IsDisabled"
                    imageUrl="assets/icons/search_black_24dp.svg">

                </button>

                <button type="submit" *ngIf="hasSecondLkp" (click)="openSecondLkp()" class="btn btn-light"
                    [disabled]="BindingProperty?BindingProperty.disabled:IsDisabled">
                    <img src="assets/icons/scan.svg" alt="">
                </button>
            </div>
        </span>

    </mat-form-field>
</div>

<bi-popup-menu class="bi-popup-menu">
    <ul class="menu">
        <li *ngIf="!(BindingProperty?BindingProperty.disabled:IsDisabled)" class="menu-item">
            <button *ngIf="!(BindingProperty?BindingProperty.disabled:IsDisabled)" type="button" class="menu-btn"
                (click)="cut()">
                <i class="fa fa-cut"></i>
                <span class="menu-text">Cut</span>
            </button>
        </li>
        <li class="menu-item">
            <button type="button" class="menu-btn" (click)="copy()">
                <i class="fa fa-copy"></i>
                <span class="menu-text">Copy</span>
            </button>
        </li>
        <li *ngIf="route" class="menu-item">
            <button type="button" class="menu-btn" (click)="GotoDefinition()">
                <i class="fa fa-search"></i>
                <span class="menu-text">Goto Definition</span>
            </button>
        </li>
    </ul>
</bi-popup-menu>


